import React, { Component } from "react";
import ImportadorExcelGenerico from "../../../../Components/ImportadorExcelGenerico";
import {
  ETIQUETAS_ACCION,
  columnaOperacion,
  mostrarResumenImportacion,
} from "../../../../Components/importarAsignacionesUI";
import {
  NOMBRE_PLANTILLA,
  construirPlantilla,
  prepararCatalogos,
  prepararContextoArchivo,
  validarFila,
} from "./plantillaAsignacionTurnos";

const columnasPreview = [
  columnaOperacion,
  {
    title: "Número Empleado",
    dataIndex: "empleadoNumero",
    key: "empleadoNumero",
    width: 130,
  },
  { title: "Empleado", dataIndex: "empleadoNombre", key: "empleadoNombre", width: 240 },
  { title: "Turno", dataIndex: "turnoNombre", key: "turnoNombre", width: 240 },
  { title: "Inicio", dataIndex: "inicioTexto", key: "inicioTexto", width: 110 },
  { title: "Fin", dataIndex: "finTexto", key: "finTexto", width: 110 },
  { title: "Estado", dataIndex: "estadoNombre", key: "estadoNombre", width: 130 },
];

const instrucciones = [
  <>
    <b>Descarga la plantilla.</b> La hoja <b>Asignaciones</b> ya viene con todas
    tus asignaciones actuales, con su <code>ID</code> y su <code>Estado</code>. Las
    hojas <b>Empleados</b> y <b>Turnos</b> son de consulta.
  </>,
  <>
    Para <b>deshabilitar</b> o <b>habilitar</b>: cambia la columna <b>Estado</b> de
    esa fila a <b>Deshabilitado</b> o <b>Activo</b>.
  </>,
  <>
    Para <b>crear</b> una asignación nueva: agrega una fila al final,{" "}
    <b>deja la columna ID vacía</b> y llena Número Empleado, Turno, Inicio, Fin y
    Estado = Activo. Las fechas van en formato <b>DD/MM/AAAA</b>.
  </>,
  <>
    Para <b>cambiarle el turno</b> a un empleado: pon <b>Deshabilitado</b> en la
    fila del turno viejo y agrega una fila nueva (sin ID) con el turno nuevo.{" "}
    <b>Se puede hacer en la misma subida.</b>
  </>,
  <>
    Desde el Excel <b>no</b> se le puede cambiar el empleado, el turno ni las
    fechas a una asignación que ya existe (una fila que ya trae ID). El sistema
    sólo admite <b>un registro por empleado y turno</b>, así que un cambio de
    fechas se hace en la pantalla de Asignación de Turnos. Si lo intentas, la fila
    sale reportada en <code>errores.xlsx</code> y no se aplica.
  </>,
  <>
    Un empleado <b>no puede tener dos asignaciones activas cuyas fechas se
    traslapen</b>.
  </>,
  <>
    Borrar una fila del archivo <b>no borra nada</b>: las filas que no vengan se
    quedan como están.
  </>,
];

class ImportarAsignacionTurnos extends Component {
  // Los ids que la subida va a apagar. Se calculan en la pasada previa sobre la
  // hoja y viajan en CADA bloque del envío: sin eso, un "cambio de turno" cuyo
  // apagado cae en otro bloque que el alta se rechazaría por traslape.
  idsDesactivados = new Set();

  prepararContexto = (hojas, catalogos) => {
    const contexto = prepararContextoArchivo(hojas, catalogos);
    this.idsDesactivados = contexto.idsDesactivados;
    return contexto;
  };

  prepararPayloadExtra = () => ({ desactivadas: [...this.idsDesactivados] });

  render() {
    return (
      <ImportadorExcelGenerico
        {...this.props}
        titulo="Importar / Actualizar Asignaciones de Turnos"
        nombreEntidadPlural="asignaciones de turno"
        endpointDatosImportar="asignacionesTurnos/datosParaImportarAsignacionesTurnos"
        endpointImportar="asignacionesTurnos/importarAsignacionesTurnos"
        nombrePlantilla={NOMBRE_PLANTILLA}
        prepararCatalogos={prepararCatalogos}
        prepararContextoArchivo={this.prepararContexto}
        prepararPayloadExtra={this.prepararPayloadExtra}
        construirPlantilla={construirPlantilla}
        validarFila={validarFila}
        columnasPreview={columnasPreview}
        instrucciones={instrucciones}
        permitirEdicion
        mostrarSwitchSoloCambios
        etiquetasAccion={ETIQUETAS_ACCION}
        tamanoLote={100}
        onImportSuccess={(resData) =>
          mostrarResumenImportacion(resData, { entidad: "asignaciones de turno" })
        }
      />
    );
  }
}

export default ImportarAsignacionTurnos;
